import { FC, MouseEvent } from "react";

import Box from "@mui/material/Box";

import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { ChevronRight, ExternalLink } from "@/icons/outlined";

interface NewsletterTileProps {
  subject: string;
  href: string | undefined;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export const NewsletterTile: FC<NewsletterTileProps> = ({ subject, href, onClick }) => (
  <Box
    component="a"
    href={href}
    onClick={onClick}
    sx={(theme) => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      minWidth: 0,
      padding: 2,
      borderRadius: theme.radius(1),
      border: `1px solid ${theme.palette.forms.border.moderate}`,
      backgroundColor: theme.palette.forms.surface.quiet,
      textDecoration: "none",
      cursor: "pointer",
      outlineColor: "transparent",
      "&:focus-visible": {
        outline: `3px solid ${theme.palette.formsComponents.global.focusOutlineColor}`,
      },
      "&:hover [data-role='newsletter-tile-external-link']": { opacity: 1 },
    })}
    data-test="org-page-newsletter-tile"
  >
    <FormTypography variant="subtitle1" vibe="brand" noWrap sx={{ minWidth: 0 }}>
      {subject}
    </FormTypography>
    <FormIcon
      data-role="newsletter-tile-external-link"
      sx={(theme) => ({
        display: { xs: "none", sm: "inline-flex" },
        flexShrink: 0,
        color: theme.palette.forms.text.brand,
        opacity: 0,
        transition: "opacity 200ms ease-out",
      })}
    >
      <ExternalLink />
    </FormIcon>
    <FormIcon
      sx={(theme) => ({
        display: { xs: "inline-flex", sm: "none" },
        flexShrink: 0,
        color: theme.palette.forms.text.brand,
      })}
    >
      <ChevronRight />
    </FormIcon>
  </Box>
);
